/**
 * $connectInsights(siteId, sourceId): opens Connect insights (Sites\Settings\AnalyticsSources) on one
 * source, or on both when sourceId is null (D78 of documentation/pr-plans/insights-s0-plan-and-seats.md).
 *
 * The dialog is told where it was opened from, read off the address at the press, since the address is
 * the page's state (D45): which view shows (?view=stats) and which activity is open (?activity=). Its
 * "Connect a different account" link returns there, with the dialog open, rather than always to Stats.
 * The server checks both against what the page offers, so nothing here reaches a URL unchecked.
 */
export function connectInsights(el) {
    return (siteId, sourceId = null) => {
        const params = new URLSearchParams(window.location.search);

        el.dispatchEvent(
            new CustomEvent("open-site-analytics-sources", {
                bubbles: true,
                composed: true,
                detail: {
                    siteId,
                    sourceId,
                    returnView: params.get("view") ?? "",
                    returnActivity: params.get("activity") ?? "",
                },
            }),
        );
    };
}
